import { api } from '@marketplace-web/core-api/core-api-client-util'

import { SubmitAutomatedSupportFeedbackArgs } from '../types/submit-automated-support-feedback'

export const submitAutomatedSupportFeedback = (args: SubmitAutomatedSupportFeedbackArgs) =>
  api.post(`/users/${args.userId}/msg_threads/${args.conversationId}/automated_support_feedback`, {
    rating: args.rating,
    help_center_session_id: args.helpCenterSessionId,
    survey_version: args.surveyVersion,
    feedback_for: args.feedbackFor,
    comment: args.comment,
  })
